import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './taxonomyObjetive.module.scss';
import { ObraProperties } from '../../../../types/ObraDetails';
import TitleHelp from '../../components/titleHelp/titleHelp';
import InfoBoxBoolean from '../../components/InfoBoxBoolean/InfoBoxBoolean';
import { ReactComponent as checkFalse } from '../../../../assets/check_false_disable.svg';
import TitleValue from '../../components/titleValue/titleValue';
import { Grid } from '@mui/material';

interface TaxonomyObjetiveProps {
  obra: ObraProperties,
  errors?: unknown
}

const TaxonomyObjetive: FC<TaxonomyObjetiveProps> = (props) => {
  const { obra } = props;
  const { t } = useTranslation();

  let ccm = false, cca = false, bio = false, wtr = false, ce = false, ppc = false;
  const taxonomicsObject = obra.taxonomics?.activities || [];
  const taxonomicsCodes = new Set(
    (obra?.taxonomics?.activities || [])
      .flatMap(activity =>
        (activity?.environmentalObjective || []).map(objective => objective.code)
      )
  );

  ccm = taxonomicsCodes.has('CCM');
  cca = taxonomicsCodes.has('CCA');
  bio = taxonomicsCodes.has('BIO');
  wtr = taxonomicsCodes.has('WTR');
  ce = taxonomicsCodes.has('CE');
  ppc = taxonomicsCodes.has('PPC');

  return (
    <div data-testid='esg-test' id='esg-nodata' className={styles.container}>
      <TitleHelp
        id='taxonomyObjetive'
        value={t('details.esg.taxonomyObjetive.helper')}
        help={t('help.esg.taxonomicObjective')}
      />
      <div className={styles.sectionFlexContainer}>
        <div>
          <div className={styles.taxom}>
            <InfoBoxBoolean
              identifier='taxonomyObjetive'
              item={{ title: '', value: t('details.esg.taxonomyObjetive.CCM') }}
              value={ccm}
              iconFalse={!ccm ? checkFalse : undefined}
              styles={
                { box: ccm ? styles.taxomBoxGreen : styles.taxomBox, value: styles.taxomValue }
              }
            />
          </div>
          <div className={styles.taxom}>
            <InfoBoxBoolean
              identifier='taxonomyObjetive'
              item={{ title: '', value: t('details.esg.taxonomyObjetive.CCA') }}
              value={cca}
              iconFalse={!cca ? checkFalse : undefined}
              styles={
                { box: cca ? styles.taxomBoxGreen : styles.taxomBox, value: styles.taxomValue }
              }
            />
          </div>
          <div className={styles.taxom}>
            <InfoBoxBoolean
              identifier='taxonomyObjetive'
              item={{ title: '', value: t('details.esg.taxonomyObjetive.WTR') }}
              value={wtr}
              iconFalse={!wtr ? checkFalse : undefined}
              styles={
                { box: wtr ? styles.taxomBoxGreen : styles.taxomBox, value: styles.taxomValue }
              }
            />
          </div>
        </div>
        <div>
          <div className={styles.taxom}>
            <InfoBoxBoolean
              identifier='taxonomyObjetive'
              item={{ title: '', value: t('details.esg.taxonomyObjetive.CE') }}
              value={ce}
              iconFalse={!ce ? checkFalse : undefined}
              styles={
                { box: ce ? styles.taxomBoxGreen : styles.taxomBox, value: styles.taxomValue }
              }
            />
          </div>
          <div className={styles.taxom}>
            <InfoBoxBoolean
              identifier='taxonomyObjetive'
              item={{ title: '', value: t('details.esg.taxonomyObjetive.PPC') }}
              value={ppc}
              iconFalse={!ppc ? checkFalse : undefined}
              styles={
                { box: ppc ? styles.taxomBoxGreen : styles.taxomBox, value: styles.taxomValue }
              }
            />
          </div>
          <div className={styles.taxom}>
            <InfoBoxBoolean
              identifier='taxonomyObjetive'
              item={{ title: '', value: t('details.esg.taxonomyObjetive.BIO') }}
              value={bio}
              iconFalse={!bio ? checkFalse : undefined}
              styles={
                { box: bio ? styles.taxomBoxGreen : styles.taxomBox, value: styles.taxomValue }
              }
            />
          </div>
        </div>
      </div>
      <div>

        {
          taxonomicsObject.map((to, i: number) => {
            return (
              <div key={i} className={styles.container}>
                <div className={styles.dapClient}>
                  <TitleValue type='input' editable={false} onlyView identifier='socialSafeguards' title={t('details.esg.taxonomyObjetive.target')} value={t('details.esg.taxonomyObjetive.' + to.environmentalObjective[0].code)} />
                </div>
                <div className={styles.containerList}>
                  <Grid container spacing={2} >
                    <Grid item xs={0.4}>
                      <div className={styles.branchTwo}></div>
                    </Grid>

                    <Grid container item xs spacing={2}>
                      <Grid item xs={4}>
                        <TitleValue
                          type="input"
                          valueStyleTaxonomy={true}
                          editable={false}
                          identifier="socialSafeguards"
                          title={t('details.esg.taxonomyObjetive.codeActivityTaxonomy')}
                          value={`${to.code.split('-').slice(1).join('-')} - ${to.name}`}
                          onlyView
                        />
                      </Grid>

                      <Grid item xs={8}>
                        <Grid container spacing={2} direction="column">
                          <Grid item xs={12}>
                            {to.nace.map((a, j: number) => {
                              return (
                                <TitleValue key={j}
                                  type="input"
                                  valueStyleTaxonomy={true}
                                  editable={false}
                                  identifier="socialSafeguards"
                                  title={t('details.esg.taxonomyObjetive.codeNaceTaxonomy')}
                                  value={`${a.code}: ${a.name}`}
                                  onlyView
                                />
                              );
                            })}
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>

                </div>
              </div>
            );
          })
        }
      </div>
    </div>
  );
};


export default TaxonomyObjetive;
